import { render, staticRenderFns } from "./transition-size.component.vue?vue&type=template&id=720b4f38&scoped=true"
import script from "./transition-size.component.vue?vue&type=script&lang=ts"
export * from "./transition-size.component.vue?vue&type=script&lang=ts"
import style0 from "./transition-size.component.vue?vue&type=style&index=0&id=720b4f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720b4f38",
  null
  
)

export default component.exports